module.exports = __webpack_public_path__ + "static/fonts/ProximaNovaA-Bold.9d62cb9f.otf";